<template>
    <div class="p-xs flex w-full items-center justify-between rounded-md border border-(--border-subtle)">
        <p class="ml-4">{{ name }}</p>
    </div>
</template>

<script setup lang="ts">
defineProps({
    name: String,
});
</script>
